import Hero from "@/components/Hero";
import OwnerSection from "@/components/Owner";
import BeforeAfter from "@/components/BeforeAfter";
import { AreaChips, FAQSection, GallerySection, ServicesGrid, Testimonials } from "@/components/Showcase";
import { CTABanner, FinalCTA, ProcessSteps, StatsRow, WhyUs } from "@/components/Marketing";
import { SEO, localBusinessJsonLd } from "@/components/SEO";
import { GENERAL_FAQS, IMAGES } from "@/data/site";

const HomePage = () => (
  <>
    <SEO
      title="Bathroom, Kitchen & Tile Remodeling in Huntsville, AL | Gregory Tile"
      description="Gregory Tile & Home Remodeling — bathroom remodeling, kitchen remodeling, and tile & wood flooring in Huntsville, Madison, Athens and surrounding Alabama counties. Licensed & insured. Free estimates."
      jsonLd={localBusinessJsonLd}
    />
    <Hero
      overline="Huntsville, Alabama · Licensed & Insured"
      lines={[
        { text: "We Bring Your Vision" },
        { text: "to Life. Quality Craftsmanship.", accent: true },
        { text: "Built to Last." },
      ]}
      sub="Bathroom remodeling, kitchen remodeling, and tile & wood flooring for Huntsville, Madison, Athens and the surrounding counties — one crew, one written price, zero surprises."
      bullets={[
        "Master tradesmen on every job",
        "Free in-home estimates",
        "2-year workmanship warranty",
        "250+ projects across North Alabama",
      ]}
      image={IMAGES.heroBath}
      imageAlt="Luxury master bathroom tile remodel in Huntsville, Alabama"
      formTitle="Get Your Free Estimate"
      formSource="home-hero"
      idPrefix="hero-estimate"
    />
    <StatsRow />
    <ServicesGrid />
    <CTABanner />
    <WhyUs />
    <OwnerSection />
    <ProcessSteps />
    <BeforeAfter />
    <GallerySection heading="Recent Work Around Huntsville" sub="Real projects by Diego and the crew — swipe through finished remodels, builds in progress, and where they started." />
    <Testimonials />
    <AreaChips />
    <FAQSection faqs={GENERAL_FAQS} />
    <FinalCTA />
  </>
);

export default HomePage;
